import I18n from "i18next";

interface MedConnectI18nPayload {
    __medconnectI18n?: unknown;
    ns?: string;
    key?: string;
    params?: Record<string, unknown>;
}

/**
 * Resolves a MedConnect text field (room welcome / room title) for display.
 *
 * New rooms carry a coded i18n payload ({ __medconnectI18n, ns, key, params }) so the text
 * is localized here in the current viewer's language (doctor and patient may use different
 * languages). Missing translations are handled by i18next's fallbackLng; if the key is unknown
 * to this client build entirely, we render a blank rather than a raw key/JSON. Old rooms carry
 * a plain, already-rendered string and are displayed verbatim — anything that is not the coded
 * payload is treated as a legacy literal.
 */
export const resolveMedConnectText = (text?: string | null): string => {
    if (!text) {
        return text ?? '';
    }

    try {
        const payload: MedConnectI18nPayload = JSON.parse(text);
        if (payload && typeof payload === 'object' && payload.__medconnectI18n) {
            const key = payload.ns ? `${payload.ns}:${payload.key}` : String(payload.key);
            if (!I18n.exists(key)) {
                return ' ';
            }
            return I18n.t(key, {...(payload.params || {})});
        }
    } catch (e) {
        // legacy literal text (old rooms) — render verbatim
    }

    return text;
};
